<template>
    <div class="code-item">
        <p class="text-code">Мы отправили код на номер <span>{{ phone }}</span></p>
        <div class="input-container number_container">
            <div>
                <input ref="input1" autocomplete="off" type="number" min="0" step="1" maxlength="1" size="1" name="auth-code-input-1" v-model="inputs.noHandleValue1" @keydown="keydownHandler" @input="inputHandler" @paste="pasteHandler"/>
            </div>
            <div>
                <input ref="input2" autocomplete="off" type="number" min="0" step="1" maxlength="1" size="1" name="auth-code-input-2" v-model="inputs.noHandleValue2" @keydown="keydownHandler" @input="inputHandler" @paste="pasteHandler"/>
            </div>
            <div>
                <input ref="input3" autocomplete="off" type="number" min="0" step="1" maxlength="1" size="1" name="auth-code-input-3" v-model="inputs.noHandleValue3" @keydown="keydownHandler" @input="inputHandler" @paste="pasteHandler"/>
            </div>
            <div>
                <input ref="input4" autocomplete="off" type="number" min="0" step="1" maxlength="1" size="1" name="auth-code-input-4" v-model="inputs.noHandleValue4" @keydown="keydownHandler" @input="inputHandler" @paste="pasteHandler"/>
            </div>
            <div>
                <input ref="input5" autocomplete="off" type="number" min="0" step="1" maxlength="1" size="1" name="auth-code-input-5" v-model="inputs.noHandleValue5" @keydown="keydownHandler" @input="inputHandler" @paste="pasteHandler"/>
            </div>
        </div>
        <div v-if="loading" class="loading">
            <svg>
                <circle class="bg" r="15" cx="20" cy="20" stroke="#E1E1E5"></circle>
                <circle class="loader" r="15" cx="20" cy="20" stroke="#717181"></circle>
            </svg>
        </div>
        <div v-if="error.exist" class="error">
            {{error.message}}
        </div>
    </div>
</template>

<script>
    import './smsCodeInpur.scss'

    export default {
      name: 'SmsCodeInput',
      data(){
        return {
            inputs: {
                noHandleValue1: '',
                noHandleValue2: '',
                noHandleValue3: '',
                noHandleValue4: '',
                noHandleValue5: '',
                value1: '',
                value2: '',
                value3: '',
                value4: '',
                value5: ''
            },
            lockInput: false,
            loading: false,
            result: null
        }
      },
      props: ['phone', 'error'],
      methods: {
          detectInput(name) {
              const index = parseInt(name.slice(name.length - 1));
              return {
                  el: this.$refs['input' + index],
                  noHandleInputValue: this.inputs['noHandleValue' + index]
              }
          },
          nextInput(name) {
              const index = parseInt(name.slice(name.length - 1));
              if (index === 5) {
                  return null;
              }

              let nextIndex = index+1;
              return {
                  el: this.$refs['input' + nextIndex],
                  noHandleInputValue: this.inputs['noHandleValue' + nextIndex]
              }

          },
          prevInput(name) {
              const index = parseInt(name.slice(name.length - 1));
              if (index === 1) {
                  return null;
              }

              let prevIndex = index - 1;
              return {
                  el: this.$refs['input' + prevIndex],
                  noHandleInputValue: this.inputs['noHandleValue' + prevIndex]
              }
          },
          keydownHandler(e) {
              console.debug('run keydown handler');

              if (this.lockInput) {
                  return false;
              }

              const nameInput = e.target.getAttribute('name');
              const i = this.detectInput(nameInput);

                let code = e.keyCode || e.which;
                if (code === 39 || code === 9) {
                    let n = this.nextInput(nameInput);
                    if (n) {
                        n.el.focus();
                    }

                    return false;
                } else if (code === 37) {
                    let p = this.prevInput(nameInput);
                    if (p) {
                        p.el.focus();
                    }

                    return false;
                } else if (!i.noHandleInputValue && code === 8) {
                    let p = this.prevInput(nameInput);
                    if (p) {
                        p.el.focus();
                        p.noHandleInputValue = '';
                    }

                    return false;
                } else if (code !== 8 && i.noHandleInputValue) {
                    return false;
                }
          },
          inputHandler(e) {
              console.debug('run input handler');

              if (this.lockInput) {
                  return false;
              }

              const nameInput = e.target.getAttribute('name');
              const i = this.detectInput(nameInput);

                if (i.noHandleInputValue) {
                    this.trySendCode();

                    if (this.lockInput) {
                        return false;
                    }

                    const n = this.nextInput(nameInput);
                    if (n) {
                        n.el.focus();
                    }
                }
          },
          pasteHandler() {
            return false;
          },
          clearInput() {
              this.value1 = '';
              this.value2 = '';
              this.value3 = '';
              this.value4 = '';
              this.value5 = '';
          },
          trySendCode() {
              console.debug('try send sms code', this.inputs);

              const self = this;
              if (this.inputs.noHandleValue1 && this.inputs.noHandleValue2 && this.inputs.noHandleValue3 && this.inputs.noHandleValue4 && this.inputs.noHandleValue5) {
                  this.lockInput = true;
//                  setTimeout(function () {
                      self.result = self.inputs.noHandleValue1 + self.inputs.noHandleValue2 + self.inputs.noHandleValue3 + self.inputs.noHandleValue4 + self.inputs.noHandleValue5;
                      self.$emit('sendCode', {code: self.result});

                      self.lockInput = false;
//                  }, 500);
              }
          },
          loadingStart() {
              this.loading = true;
          },
          loadingComplete() {
              this.loading = false;
          }
      },
      components: {
      }
    }

//    var $allInputs = $smsCodeInput1.add($smsCodeInput2).add($smsCodeInput3).add($smsCodeInput4).add($smsCodeInput5);

    /*
    $allInputs.on('input keydown', function () {
        if (/^\d*$/.test(this.value)) {
            this.oldValue = this.value;
            this.oldSelectionStart = this.selectionStart;
            this.oldSelectionEnd = this.selectionEnd;
        } else if (this.hasOwnProperty("oldValue")) {
            this.value = this.oldValue;
            this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
        }
    });

    $allInputs.on('input keydown', function () {
        $(self).trigger('inputInAction');
    });

    $allInputs.on('paste', function () {
        return false;
    });*/

</script>